import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Box, Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { StyledContactWidgetSkeleton } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/super-agent/components/ContactWidget/styles";

const MAX_COUNT_TO_RENDER = 3;
const GAP_Y = 8;
const GAP_X = 4;

const BlueGradient = () => (
    <linearGradient
        id="btnBlueGray"
        x1="0%"
        x2="0%"
    >
        <animate
            attributeName="x1"
            dur="1s"
            repeatCount="indefinite"
            from="0%"
            to="200%"
        ></animate>
        <stop
            offset="0%"
            stopColor="#D8E4F5"
        ></stop>
        <stop
            offset="50%"
            stopColor="#CFDBEC"
        ></stop>
        <stop
            offset="100%"
            stopColor="#D8E4F5"
        ></stop>
    </linearGradient>
);

type Props = {
    count: number;
};

export const ContactWidgetSkeleton = ({ count }: Props) => {
    const countToRender = count > 1 ? MAX_COUNT_TO_RENDER : 1;

    return (
        <Box
            position="relative"
            width={`${253 + (countToRender - 1) * GAP_X}px`}
            height={`${144 + (countToRender - 1) * GAP_Y}px`}
            margin="0 0 16px 0"
        >
            {Array.from({ length: countToRender }).map((_, index) => (
                <StyledContactWidgetSkeleton
                    key={index}
                    top={`${(countToRender - 1 - index) * GAP_Y}px`}
                    left={`${(countToRender - 1 - index) * GAP_X}px`}
                >
                    <Flex
                        justifyContent="space-between"
                        margin="0 0 20px 0"
                    >
                        <Stack gap="4px">
                            <PixelPlaceholderLoader
                                width={179}
                                height={22}
                            />
                            <Flex
                                gap="8px"
                                alignItems="center"
                            >
                                <PixelPlaceholderLoader
                                    width={53}
                                    height={14}
                                />
                                <Text
                                    fontVariant="listItem3"
                                    color={colorsPalettes.carbon[200]}
                                >
                                    •
                                </Text>
                                <PixelPlaceholderLoader
                                    width={53}
                                    height={14}
                                />
                            </Flex>
                        </Stack>
                        <PixelPlaceholderLoader
                            width={32}
                            height={32}
                            ShapeMarkup={BlueGradient}
                            id="btnBlueGray"
                        />
                    </Flex>
                    <Flex justifyContent="space-between">
                        <Stack gap="4px">
                            <Flex gap="9px">
                                <SWReactIcons
                                    iconName="email"
                                    size="12px"
                                    iconColor={colorsPalettes.carbon[500]}
                                />
                                <PixelPlaceholderLoader
                                    width={139}
                                    height={14}
                                />
                            </Flex>
                            <Flex gap="9px">
                                <SWReactIcons
                                    iconName="phone-outlined"
                                    size="12px"
                                    iconColor={colorsPalettes.carbon[500]}
                                />
                                <PixelPlaceholderLoader
                                    width={98}
                                    height={14}
                                />
                            </Flex>
                            <Flex gap="9px">
                                <SWReactIcons
                                    iconName="mobile-ios"
                                    size="12px"
                                    iconColor={colorsPalettes.carbon[500]}
                                />
                                <PixelPlaceholderLoader
                                    width={98}
                                    height={14}
                                />
                            </Flex>
                        </Stack>
                        <Stack gap="4px">
                            <PixelPlaceholderLoader
                                width={14}
                                height={14}
                                ShapeMarkup={BlueGradient}
                                id="btnBlueGray"
                            />
                            <PixelPlaceholderLoader
                                width={14}
                                height={14}
                                ShapeMarkup={BlueGradient}
                                id="btnBlueGray"
                            />
                            <PixelPlaceholderLoader
                                width={14}
                                height={14}
                                ShapeMarkup={BlueGradient}
                                id="btnBlueGray"
                            />
                        </Stack>
                    </Flex>
                </StyledContactWidgetSkeleton>
            ))}
        </Box>
    );
};
